import React, { FC, useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { OrgPolicy, defaultPolicies } from '../../models/api-models/org-policies/org-policies';
import { TermsAndConditions } from './TermsAndConditions/TermsAndConditions'

export const PolicyContainer: FC = () => {
    const { orgMnemonic, policyType } = useParams();
    const [policy, setPolicy] = useState<OrgPolicy>(null);
    const [initialized, setInitialized] = useState(false);
    const supportedPolicies = ['sms-terms'];
  
    useEffect(() => {
        const policy = defaultPolicies.find(x => x.orgMnemonic === orgMnemonic);
        if (supportedPolicies.includes(policyType)) {
            setPolicy(policy);
        }
        setInitialized(true);
    }, []);

    return (
        <div className="policy-content">
            {!initialized && <div>Load..</div>}
            {initialized && policy && <TermsAndConditions policy={policy} />}
            {initialized && !policy && <div className="policy-header">Not Found</div>}
        </div>
    )
} 